import React, { useState } from "react";

import TextField from "@material-ui/core/TextField";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import {
  Grid,
  LinearProgress,
  Select,
  OutlinedInput,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

// styles
import useStyles from "../../styles";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";

export default function LegalInformation(props) {
  var classes = useStyles();
  var theme = useTheme();

  return (
    <form
      className={classes.root + " " + classes.subformsc}
      noValidate
      autoComplete="off"
    >
      <Grid container spacing={2}>
        <Grid
          item
          lg={3}
          md={12}
          sm={12}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <FormControl component="fieldset" row>
            <FormLabel className={classes.labeltextc} component="legend">
              What is the legal form of the customer?
            </FormLabel>
          </FormControl>
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <FormControl component="fieldset" style={{ width: "85%" }} row>
            <RadioGroup aria-label="trade" name="trade" row>
              <Grid container spacing={1} style={{ marginTop: "-50px" }}>
                <Grid
                  item
                  lg={3}
                  md={6}
                  sm={6}
                  xs={12}
                  className={classes.center_elements + " " + classes.griditemc}
                >
                  <FormControlLabel
                    value="Public Company"
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labeltextc}>
                        Public Company
                      </Typography>
                    }
                  />
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={6}
                  sm={6}
                  xs={12}
                  className={classes.center_elements + " " + classes.griditemc}
                >
                  <FormControlLabel
                    value="Private Company"
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labeltextc}>
                        Private Company
                      </Typography>
                    }
                  />
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={6}
                  sm={6}
                  xs={12}
                  className={classes.center_elements + " " + classes.griditemc}
                >
                  <FormControlLabel
                    value="State-owned Company"
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labeltextc}>
                        State Owned Company
                      </Typography>
                    }
                  />
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={6}
                  sm={6}
                  xs={12}
                  className={classes.center_elements + " " + classes.griditemc}
                >
                  <FormControlLabel
                    value="Other"
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labeltextc}>
                        Other
                      </Typography>
                    }
                  />

                  <TextField
                   style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}
                    InputProps={{
                      className: classes.inputcc + " " + classes.notchedOutline,
                    }}
                    InputLabelProps={{
                      // shrink: true,
                      className:
                        classes.matlabelc + " " + classes.nonshrinklevalc,
                    }}
                    // style={{ marginTop: "-10px" }}
                    className={classes.textfieldvaluec}
                    id="enter_other_id"
                    label="OTHER"
                    type="text"
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <FormControl component="fieldset" row>
            <FormLabel className={classes.labeltextc} component="legend" style={{lineHeight: 1.3}}>
              Is your institution regulated in its banking / other activities by
              a financial services regulator?
            </FormLabel>
          </FormControl>
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <FormControl component="fieldset" style={{ width: "85%" }} row>
            <RadioGroup aria-label="trade" name="trade" row>
              <Grid container spacing={1} style={{ marginTop: "-50px" }}>
                <Grid
                  item
                  lg={3}
                  md={6}
                  sm={6}
                  xs={12}
                  className={classes.center_elements + " " + classes.griditemc}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labeltextc}>
                        Yes
                      </Typography>
                    }
                  />
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={6}
                  sm={6}
                  xs={12}
                  className={classes.center_elements + " " + classes.griditemc}
                >
                  <FormControlLabel
                    value="No"
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labeltextc}>No</Typography>
                    }
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid
          item
          lg={2}
          md={3}
          sm={12}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
           style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}
            InputProps={{
              className: classes.inputcc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              // shrink: true,
              className: classes.matlabelc + " " + classes.nonshrinklevalc,
            }}
            // style={{ marginTop: "-15px", width: 150 }}
            className={classes.textfieldvaluec}
            id="regulatoe name"
            label="NAME OF REGULATOR(S)"
            type="text"
          />
        </Grid>
        <Grid
          item
          lg={2}
          md={3}
          sm={12}
          xs={12}
          className={classes.center_elements + " " + classes.griditemc}
        >
          <TextField
           style={window.innerWidth > 500 ? {width: '100%'} : {width: '96%'}}
            InputProps={{
              className: classes.inputcc + " " + classes.notchedOutline,
            }}
            InputLabelProps={{
              // shrink: true,
              className: classes.matlabelc + " " + classes.nonshrinklevalc,
            }}
            // style={{ marginTop: "-15px" }}
            className={classes.textfieldvaluec}
            id="register no"
            label="REGISTETRAIN NO"
            type="text"
          />
        </Grid>
      </Grid>
    </form>
  );
}
